var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.71657 2L8.85261 6.61227L8.85466 6.61396C9.53599 7.11128 9.87685 7.3601 10.2502 7.45621C10.5802 7.54117 10.9271 7.54117 11.2571 7.45621C11.6308 7.36001 11.9726 7.11047 12.6552 6.61227C12.6552 6.61227 16.5909 3.60594 18.791 2M1.71191 11.8002V4.2002C1.71191 3.08009 1.71191 2.51962 1.93091 2.0918C2.12355 1.71547 2.43071 1.40973 2.80879 1.21799C3.2386 1 3.80168 1 4.92699 1H16.5809C17.7063 1 18.2681 1 18.6979 1.21799C19.076 1.40973 19.3842 1.71547 19.5768 2.0918C19.7956 2.5192 19.7956 3.07899 19.7956 4.19691V11.8036C19.7956 12.9215 19.7956 13.4805 19.5768 13.9079C19.3842 14.2842 19.076 14.5905 18.6979 14.7822C18.2686 15 17.707 15 16.5839 15H4.92369C3.80058 15 3.23818 15 2.80879 14.7822C2.43071 14.5905 2.12355 14.2842 1.93091 13.9079C1.71191 13.4801 1.71191 12.9203 1.71191 11.8002Z",
    stroke: "#928689",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.fb30cbfe1819d1f34642882adaa50550.svg";
export { ForwardRef as ReactComponent };